export class Strategy {

    /**
     * @type {number}
     */
    id;
    /**
     * @type {string}
     */
    title;
    /**
     * @type {string}
     */
    description;
    /**
     * @type {string}
     */
    image;
    /**
     * @type {string}
     */
    url;
    isLink = true;

    get localUrl() {
        if (!this.isLink) return "#";

        const split = this.url.split("/");
        const url = split.at(-1) || split.at(-2);
        return "/support/" + url;
    }

    constructor(id, title, description, image, url) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.image = image;
        this.url = url;
    }

    setIsLink(isLink) {
        this.isLink = isLink;
        return this;
    }

}